module.exports = __webpack_public_path__ + "line.gif";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/line.gif
// module id = 304
// module chunks = 319 323